import { useTranslation } from 'react-i18next';

import GeneralSettingsSection from './GeneralSettingsSection/GeneralSettingsSection';
import ManagementSettingsSection from './ManagementSettingsSection/ManagementSettingsSection';

const GeneralTab = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col space-y-4">
      <span className="text-xl font-semibold">{t('workspaces.general')}</span>
      <GeneralSettingsSection />
      <ManagementSettingsSection />
    </div>
  );
};

export default GeneralTab;
